import { Box, Stack, Typography, useTheme, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function ProjectCard({ e, delay = 0 }) {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay, ease: [0.25, 0.1, 0.25, 1] }}
      style={{ height: "100%", width: "100%" }}
    >
      <Box
        onClick={() => navigate(`details/${e?._id}`)}
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          borderRadius: 2,
          overflow: "hidden",
          cursor: "pointer",
          background: "rgba(255, 255, 255, 0.02)",
          border: "1px solid rgba(255, 255, 255, 0.05)",
          transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            transform: "translateY(-8px)",
            // borderColor: `${theme.palette.primary.main}50`,
            // boxShadow: `0 20px 40px -10px rgba(0,0,0,0.5), 0 0 20px -5px ${theme.palette.primary.main}30`,
            "& .main-image": {
              transform: "scale(1.1)",
            },
            "& .content-wrapper": {
              transform: "translateY(0)",
            },
            "& .action-btn": {
              opacity: 1,
              transform: "translateX(0)",
            },
          },
        }}
      >
        <Box
          className="main-image"
          sx={{
            width: "100%",
            height: "100%",
            transition: "transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            src={e?.image}
            alt={e?.title}
          />
        </Box>

        <Box
          className="overlay-gradient"
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.1) 60%, transparent 100%)",
            opacity: 0.8,
            transition: "all 0.5s ease",
          }}
        />

        <Stack
          className="content-wrapper"
          justifyContent="flex-end"
          sx={{
            position: "absolute",
            inset: 0,
            p: { xs: 2.5, sm: 3.5 },
            transform: "translateY(15px)", // Pushed down initially
            transition: "transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
          >
            <Box sx={{ maxWidth: "80%" }}>
              <Typography
                variant="caption"
                sx={{
                  color: "primary.light",
                  fontWeight: 600,
                  letterSpacing: 1,
                  textTransform: "uppercase",
                  mb: 0.5,
                  display: "block",
                }}
              >
                Project
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  color: "white",
                  fontWeight: 700,
                  letterSpacing: "-0.5px",
                  lineHeight: 1.2,
                  textShadow: "0 2px 10px rgba(0,0,0,0.5)",
                }}
              >
                {e?.title}
              </Typography>
            </Box>

            <IconButton
              className="action-btn"
              size="small"
              sx={{
                bgcolor: "primary.main",
                color: "#fff",
                opacity: 0,
                transform: "translateX(-10px)",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0.1s",
                "&:hover": {
                  bgcolor: "primary.light",
                },
              }}
            >
              <ArrowForwardIcon fontSize="small" />
            </IconButton>
          </Box>
        </Stack>
      </Box>
    </motion.div>
  );
}
